import { Link, matchPath, useLocation } from "react-router-dom";
import sidebarLogo from "../../assets/images/logo-transparent.png";
import { useEffect, useState } from "react";
import { useApplicationContext } from "../../context/ApplicationContext";
import { usePermission } from "../../hooks/usePermission";
import { APP, appText } from "../../constant/theme";
import SidebarAchieverIcon from "./SidebarAchieverIcon";
import userIcon from "../../assets/images/icons/user_white.png";
import tysIcon from "../../assets/images/icons/tys_white.png";
import oneToOneIcon from "../../assets/images/icons/one_to_one_white.png";
import referralsIcon from "../../assets/images/icons/referrals_white.png";
import visitorsIcon from "../../assets/images/icons/visitors_white.png";
import mastersIcon from "../../assets/images/icons/masters_white.png";
import eventsIcon from "../../assets/images/icons/events_white.png";
import dashboardIcon from "../../assets/images/icons/dashboard_white.png";
import reportsIcon from "../../assets/images/icons/reports_white.png";
import testimonialsIcon from "../../assets/images/icons/testimonials_white.png";
import newsIcon from "../../assets/images/icons/news_white.png";
import rolesIcon from "../../assets/images/icons/roles_white.png";
import incomesIcon from "../../assets/images/icons/incomes_white.png";
import meetingSchedulesIcon from "../../assets/images/icons/meeting_schedules_white.png";
import monthlyFeesIcon from "../../assets/images/icons/monthly_fees_white.png";
import leadsIcon from "../../assets/images/icons/leads_white.png";

const Sidebar = () => {
  const { user } = useApplicationContext();
  const { hasPermission } = usePermission();

  const closeDrawer = () => {
    let html = document.querySelector("html");
    html.classList.remove("layout-menu-expanded");
  };

  const isSuperAdmin = user?.user_type === 1 ? 1 : 0;
  const isCountryAdmin = user?.user_type === 6 ? 1 : 0;
  const isStateAdmin = user?.user_type === 7 ? 1 : 0;
  const isRegionAdmin = user?.user_type === 2 ? 1 : 0;
  const isChapterAdmin = user?.user_type === 3 ? 1 : 0;

  const location = useLocation();
  const isParentPath = (url) => matchPath(url, location.pathname) != null;

  const [showMastersSubMenu, setShowMastersSubMenu] = useState(false);
  const [showReportsSubMenu, setShowReportsSubMenu] = useState(false);
  const [showVisitorsSubMenu, setShowVisitorsSubMenu] = useState(false);
  const [showFinanceSubMenu, setShowFinanceSubMenu] = useState(false);

  const dashboardRoute = () =>
    isParentPath("/") || isParentPath("/home") || isParentPath("/dashboard");

  const userRoutes = () =>
    isParentPath("/users") ||
    isParentPath("/user/create") ||
    isParentPath("/user/:id/edit");

  const regionRoutes = () =>
    isParentPath("/regions") ||
    isParentPath("/create/region") ||
    isParentPath("/region/:id/edit");

  const countryRoutes = () =>
    isParentPath("/countries") ||
    isParentPath("/create/country") ||
    isParentPath("/country/:id/edit");

  const stateRoutes = () =>
    isParentPath("/states") ||
    isParentPath("/create/state") ||
    isParentPath("/state/:id/edit");

  const chapterRoutes = () =>
    isParentPath("/chapters") ||
    isParentPath("/create/chapter") ||
    isParentPath("/chapter/:id/edit");

  const countryAdminRoutes = () =>
    isParentPath("/country-admin-users") ||
    isParentPath("/country-admin-user/create") ||
    isParentPath("/country-admin-user/:id/edit");

  const stateAdminRoutes = () =>
    isParentPath("/state-admin-users") ||
    isParentPath("/state-admin-user/create") ||
    isParentPath("/state-admin-user/:id/edit");

  const regionAdminRoutes = () =>
    isParentPath("/region-admin-users") ||
    isParentPath("/region-admin-user/create") ||
    isParentPath("/region-admin-user/:id/edit");

  const chapterAdminRoutes = () =>
    isParentPath("/chapter-admin-users") ||
    isParentPath("/chapter-admin-user/create") ||
    isParentPath("/chapter-admin-user/:id/edit");

  const categoryRoutes = () =>
    isParentPath("/category") ||
    isParentPath("/create/category") ||
    isParentPath("/category/:id/edit");

  const incomeCategoryRoutes = () =>
    isParentPath("/income-category") ||
    isParentPath("/create/income-category") ||
    isParentPath("/income-category/:id/edit");

  const expenseCategoryRoutes = () =>
    isParentPath("/expense-category") ||
    isParentPath("/create/expense-category") ||
    isParentPath("/expense-category/:id/edit");

  const postsCategoryRoutes = () =>
    isParentPath("/posts-category") ||
    isParentPath("/create/posts-category") ||
    isParentPath("/posts-category/:id/edit");

  const sponsorsCategoryRoutes = () =>
    isParentPath("/sponsors-category") ||
    isParentPath("/create/sponsors-category") ||
    isParentPath("/sponsors-category/:id/edit");

  const bloodgroupRoutes = () =>
    isParentPath("/blood-groups") ||
    isParentPath("/create/blood-group") ||
    isParentPath("/blood-group/:id/edit");

  const crownRoutes = () =>
    isParentPath("/crowns") ||
    isParentPath("/create/crown") ||
    isParentPath("/crown/:id/edit");

  const timerRoutes = () =>
    isParentPath("/timers") ||
    isParentPath("/create/timer") ||
    isParentPath("/timer/:id/edit");

  const timerAccessRoutes = () => isParentPath("/timer-access");

  const chapterFinanceAccessRoutes = () =>
    isParentPath("/chapter-finance-access");

  const roleRoutes = () =>
    isParentPath("/roles") ||
    isParentPath("/create/role") ||
    isParentPath("/role/:id/edit");

  const userRoleRoutes = () =>
    isParentPath("/user-roles") ||
    isParentPath("/create/user-role") ||
    isParentPath("/user-role/:id/edit");

  const tyfcbRoutes = () => isParentPath("/tyfcbs");

  const testimonialsRoutes = () => isParentPath("/testimonials");

  const meetingSchedulesRoutes = () => isParentPath("/meeting-schedules");

  const meetingAttendanceRoutes = () => isParentPath("/weekly-meetings");

  const MeetingFeesRoutes = () => isParentPath("/monthly-fees");

  const weeklyMeetingFeesRoutes = () => isParentPath("/meeting-fees");

  const onetooneRoutes = () => isParentPath("/one-to-one");

  const referralRoutes = () => isParentPath("/referrals");

  // const visitorRoutes = () =>
  //   isParentPath("/visitors");

  const visitorGeneralRoutes = () => isParentPath("/visitors/general");

  const visitorChiefGuestRoutes = () => isParentPath("/visitors/chief-guest");

  const visitorPowerDateRoutes = () => isParentPath("/visitors/power-date");

  const visitorInductionsRoutes = () => isParentPath("/visitors/inductions");

  const eventRoutes = () =>
    isParentPath("/events") ||
    isParentPath("/create/event") ||
    isParentPath("/event/:id/edit");

  const newsRoutes = () =>
    isParentPath("/news") ||
    isParentPath("/news/create") ||
    isParentPath("/news/:id/edit");

  const feedPostsRoutes = () => isParentPath("/feed-posts");

  const incomesRoutes = () => isParentPath("/incomes");

  const expensesRoutes = () => isParentPath("/expenses");

  const sponsorsRoutes = () => isParentPath("/sponsors");

  const financeRoutes = () =>
    isParentPath("/incomes") ||
    isParentPath("/expenses") ||
    isParentPath("/sponsors");

  const pointsRoutes = () => isParentPath("/points");

  const pointsSystemRoutes = () => isParentPath("/points-system");

  const settingsRoutes = () =>
    isParentPath("/attendance-qr-code") || isParentPath("/settings");

  const forumSettingsRoutes = () => isParentPath("/forum-settings");
  const memberMonthlyReportsRoutes = () =>
    isParentPath("/member_monthly_reports");

  const tyfcbReportsRoutes = () => isParentPath("/reports/tyfcbs");

  const bizgivenReportsRoutes = () => isParentPath("/reports/biz-given");

  const onetooneReportsRoutes = () => isParentPath("/reports/one-to-one");

  const referralReportsRoutes = () => isParentPath("/reports/referrals");

  const visitorsReportsRoutes = () => isParentPath("/reports/visitors");

  const visitorsGeneralReportsRoutes = () =>
    isParentPath("/reports/visitors-general");

  const visitorsChiefGuestReportsRoutes = () =>
    isParentPath("/reports/visitors-chief-guest");

  const visitorsPowerDateReportsRoutes = () =>
    isParentPath("/reports/visitors-power-date");

  const visitorsInductionReportsRoutes = () =>
    isParentPath("/reports/visitors-inductions");

  const feesReportsRoutes = () => isParentPath("/reports/fees");

  const overallReportsRoutes = () => isParentPath("/reports/overall");

  const ledgerReportsRoutes = () => isParentPath("/reports/ledger");

  const membershipExpiryRenewalReportsRoutes = () =>
    isParentPath("/reports/membership-expiry-renewals");

  const attendanceReportsRoutes = () => isParentPath("/reports/attendance");

  const chapterWiseBusinessReportsRoutes = () =>
    isParentPath("/reports/chapter-wise-business");

  const chapterWiseOnetoOneReportsRoutes = () =>
    isParentPath("/reports/chapter-wise-one-to-one");

  const chapterWiseReferralsReportsRoutes = () =>
    isParentPath("/reports/chapter-wise-referrals");

  const chapterWiseVisitorsReportsRoutes = () =>
    isParentPath("/reports/chapter-wise-visitors");

  useEffect(() => {
    if (
      isParentPath("/reports/tyfcbs") ||
      isParentPath("/reports/biz-given") ||
      isParentPath("/reports/one-to-one") ||
      isParentPath("/reports/referrals") ||
      isParentPath("/reports/visitors") ||
      isParentPath("/reports/visitors-general") ||
      isParentPath("/reports/visitors-chief-guest") ||
      isParentPath("/reports/visitors-power-date") ||
      isParentPath("/reports/visitors-inductions") ||
      isParentPath("/reports/fees") ||
      isParentPath("/reports/attendance") ||
      isParentPath("/reports/overall") ||
      isParentPath("/reports/ledger") ||
      isParentPath("/reports/membership-expiry-renewals") ||
      isParentPath("/reports/chapter-wise-business") ||
      isParentPath("/reports/chapter-wise-one-to-one") ||
      isParentPath("/reports/chapter-wise-referrals") ||
      isParentPath("/reports/chapter-wise-visitors") ||
      isParentPath("/reports/points")
    ) {
      setShowReportsSubMenu(true);
    } else {
      setShowReportsSubMenu(false);
    }

    if (
      isParentPath("/visitors/general") ||
      isParentPath("/visitors/chief-guest") ||
      isParentPath("/visitors/power-date") ||
      isParentPath("/visitors/inductions")
    ) {
      setShowVisitorsSubMenu(true);
    } else {
      setShowVisitorsSubMenu(false);
    }

    if (
      isParentPath("/incomes") ||
      isParentPath("/expenses") ||
      isParentPath("/sponsors")
    ) {
      setShowFinanceSubMenu(true);
    } else {
      setShowFinanceSubMenu(false);
    }

    if (
      isParentPath("/countries") ||
      isParentPath("/create/country") ||
      isParentPath("/region/:id/country") ||
      isParentPath("/states") ||
      isParentPath("/create/state") ||
      isParentPath("/region/:id/state") ||
      isParentPath("/regions") ||
      isParentPath("/create/region") ||
      isParentPath("/region/:id/edit") ||
      isParentPath("/country-admin-users") ||
      isParentPath("/country-admin-user/create") ||
      isParentPath("/country-admin-user/:id/edit") ||
      isParentPath("/state-admin-users") ||
      isParentPath("/state-admin-user/create") ||
      isParentPath("/state-admin-user/:id/edit") ||
      isParentPath("/region-admin-users") ||
      isParentPath("/region-admin-user/create") ||
      isParentPath("/region-admin-user/:id/edit") ||
      isParentPath("/chapters") ||
      isParentPath("/create/chapter") ||
      isParentPath("/chapter/:id/edit") ||
      isParentPath("/chapter-admin-users") ||
      isParentPath("/chapter-admin-user/create") ||
      isParentPath("/chapter-admin-user/:id/edit") ||
      isParentPath("/blood-groups") ||
      isParentPath("/create/blood-group") ||
      isParentPath("/blood-group/:id/edit") ||
      isParentPath("/timers") ||
      isParentPath("/create/timer") ||
      isParentPath("/timer/:id/edit") ||
      isParentPath("/timer-access") ||
      isParentPath("/chapter-finance-access") ||
      isParentPath("/category") ||
      isParentPath("/create/category") ||
      isParentPath("/category/:id/edit") ||
      isParentPath("/income-category") ||
      isParentPath("/create/income-category") ||
      isParentPath("/income-category/:id/edit") ||
      isParentPath("/expense-category") ||
      isParentPath("/create/expense-category") ||
      isParentPath("/expense-category/:id/edit") ||
      isParentPath("/posts-category") ||
      isParentPath("/create/posts-category") ||
      isParentPath("/posts-category/:id/edit") ||
      isParentPath("/sponsors-category") ||
      isParentPath("/create/sponsors-category") ||
      isParentPath("/sponsors-category/:id/edit") ||
      isParentPath("/crowns") ||
      isParentPath("/create/crown") ||
      isParentPath("/crown/:id/edit") ||
      isParentPath("/user-roles") ||
      isParentPath("/create/user-role") ||
      isParentPath("/user-role/:id/edit")
    ) {
      setShowMastersSubMenu(true);
    } else {
      setShowMastersSubMenu(false);
    }
  }, [location]);

  const toggleMastersSubMenu = () => {
    setShowMastersSubMenu(!showMastersSubMenu);
  };

  const toggleReportsSubMenu = () => {
    setShowReportsSubMenu(!showReportsSubMenu);
  };

  const toggleVisitorsSubMenu = () => {
    setShowVisitorsSubMenu(!showVisitorsSubMenu);
  };

  const toggleFinanceSubMenu = () => {
    setShowFinanceSubMenu(!showFinanceSubMenu);
  };

  return (
    <aside
      id="layout-menu"
      className="layout-menu menu-vertical menu bg-menu-theme darkbg"
    >
      <div className="app-brand demo text-center">
        <Link to="/" className="app-brand-link d-block">
          <span className="app-brand-text demo menu-text fw-bolder ms-2">
            <img src={sidebarLogo} alt={appText(APP.logoAlt)} />
          </span>
        </Link>
        <div
          className="layout-menu-toggle menu-link text-large ms-auto"
          onClick={closeDrawer}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
      </div>

      <div className="menu-inner-shadow"></div>

      <ul className="menu-inner dark-bg-inner py-3">
        <li className={dashboardRoute() ? "menu-item active" : "menu-item"}>
          <Link className="menu-link" to="/dashboard" onClick={closeDrawer}>
            <div>
              <SidebarAchieverIcon src={dashboardIcon} alt="Dashboard" />
            </div>
            <div data-i18n="Analytics">Dashboard</div>
          </Link>
        </li>

        {hasPermission("members-list") && (
          <li className={userRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/users" onClick={closeDrawer}>
              <div>
                <SidebarAchieverIcon src={userIcon} alt="Members" />
              </div>
              <div data-i18n="Analytics">Members</div>
            </Link>
          </li>
        )}

        {hasPermission("meeting-schedules-list") && (
          <li
            className={
              meetingAttendanceRoutes() ? "menu-item active" : "menu-item"
            }
          >
            <Link
              className="menu-link"
              to="/weekly-meetings"
              onClick={closeDrawer}
            >
              <SidebarAchieverIcon src={meetingSchedulesIcon} alt="Meeting Schedules" />
              <div data-i18n="Analytics">Meeting Schedules</div>
            </Link>
          </li>
        )}

        {/* {hasPermission("monthly-fees-list") && (
          <li className={weeklyMeetingFeesRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/meeting-fees" onClick={closeDrawer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.32"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.12411 8H21.8758C21.9467 9.20109 22 10.8266 22 13C22 16.4843 21.8631 18.5605 21.7362 19.7371C21.6422 20.6088 21.0518 21.281 20.1903 21.4442C18.8494 21.6983 16.3428 22 12 22C7.65725 22 5.15055 21.6983 3.80967 21.4442C2.94826 21.281 2.35785 20.6088 2.26379 19.7371C2.13682 18.5605 2 16.4843 2 13C2 10.8266 2.05324 9.20109 2.12411 8ZM6.5 12.6815C6.5 12.0806 6.93315 11.6082 7.5337 11.5868C8.3136 11.559 9.6669 11.5275 12 11.5069C14.5069 11.4848 15.8826 11.5197 16.6312 11.5599C17.1554 11.5881 17.5 11.9946 17.5 12.5196V12.9107C17.5 13.4726 17.1157 13.9093 16.5543 13.934C15.7898 13.9675 14.4235 14 12 14C9.5765 14 8.21025 13.9675 7.44565 13.934C6.88435 13.9093 6.5 13.4726 6.5 12.9107V12.6815ZM6.5 17.0891C6.5 16.5276 6.8844 16.0793 7.44515 16.0503C7.97275 16.0231 8.7795 16.0001 10 16.0001C11.2205 16.0001 12.0272 16.0231 12.5548 16.0503C13.1156 16.0793 13.5 16.5276 13.5 17.0891V17.4111C13.5 17.9726 13.1156 18.4208 12.5548 18.4498C12.0272 18.4771 11.2205 18.5001 10 18.5001C8.7795 18.5001 7.97275 18.4771 7.44515 18.4498C6.8844 18.4208 6.5 17.9726 6.5 17.4111V17.0891Z"
                />
                <path d="M17.915 2.03126C18.2276 2.05703 18.4424 2.28598 18.4636 2.59889C18.4831 2.88636 18.5 3.32917 18.5 4C18.5 4.10776 18.4995 4.20964 18.4987 4.30593C19.1999 4.38632 19.7561 4.47356 20.1902 4.55581C21.0516 4.71901 21.642 5.39115 21.7361 6.26285C21.7839 6.7055 21.833 7.27555 21.8758 8H2.12402C2.16677 7.27555 2.21593 6.7055 2.2637 6.26285C2.35776 5.39115 2.94817 4.71902 3.80958 4.55581C4.24369 4.47355 4.8 4.3863 5.50125 4.30591C5.50045 4.20962 5.5 4.10775 5.5 4C5.5 3.32917 5.5169 2.88636 5.5364 2.59889C5.5576 2.28598 5.7724 2.05703 6.08495 2.03126C6.29765 2.01372 6.5938 2 7 2C7.4062 2 7.70235 2.01372 7.91505 2.03126C8.2276 2.05703 8.4424 2.28598 8.4636 2.59889C8.4831 2.88636 8.5 3.32917 8.5 4C8.5 4.0254 8.5 4.05047 8.49995 4.07521C9.50645 4.02844 10.6666 4 11.9999 4C13.3332 4 14.4935 4.02845 15.5 4.07522L15.5 4C15.5 3.32917 15.5169 2.88636 15.5364 2.59889C15.5576 2.28598 15.7724 2.05703 16.0849 2.03126C16.2976 2.01372 16.5938 2 17 2C17.4062 2 17.7023 2.01372 17.915 2.03126Z" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5337 11.5868C6.93315 11.6081 6.5 12.0805 6.5 12.6815V12.9107C6.5 13.4725 6.88435 13.9093 7.44565 13.9339C8.21025 13.9674 9.5765 14 12 14C14.4235 14 15.7897 13.9674 16.5543 13.9339C17.1156 13.9093 17.5 13.4725 17.5 12.9107V12.5196C17.5 11.9946 17.1554 11.5881 16.6312 11.5599C15.8825 11.5196 14.5069 11.4847 12 11.5069C9.6669 11.5274 8.3136 11.559 7.5337 11.5868ZM7.44515 16.0503C6.8844 16.0793 6.5 16.5275 6.5 17.089V17.411C6.5 17.9725 6.8844 18.4208 7.44515 18.4498C7.97275 18.477 8.7795 18.5 10 18.5C11.2205 18.5 12.0272 18.477 12.5548 18.4498C13.1156 18.4208 13.5 17.9725 13.5 17.411V17.089C13.5 16.5275 13.1156 16.0793 12.5548 16.0503C12.0272 16.023 11.2205 16 10 16C8.7795 16 7.97275 16.023 7.44515 16.0503Z"
                />
              </svg>
              <div data-i18n="Analytics">Meeting Fees</div>
            </Link>
          </li>
        )} */}

        {hasPermission("monthly-fees-list") && (
          <li className={MeetingFeesRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/monthly-fees" onClick={closeDrawer}>
              <SidebarAchieverIcon src={monthlyFeesIcon} alt="Monthly Fees" />
              <div data-i18n="Analytics">Monthly Meeting Fees</div>
            </Link>
          </li>
        )}

        {hasPermission("121s-list") && (
          <li className={onetooneRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/one-to-one" onClick={closeDrawer}>
              <SidebarAchieverIcon src={oneToOneIcon} alt="R2R" />
              <div data-i18n="Analytics">R2R</div>
            </Link>
          </li>
        )}
        {hasPermission("referrals-list") && (
          <li className={referralRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/referrals" onClick={closeDrawer}>
              <div>
                <SidebarAchieverIcon src={referralsIcon} alt="RFLs" />
              </div>
              <div data-i18n="Analytics">RFLs</div>
            </Link>
          </li>
        )}

        {hasPermission("tyfcbs-list") && (
          <li className={tyfcbRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/tyfcbs" onClick={closeDrawer}>
              <SidebarAchieverIcon src={tysIcon} alt="TYNs" />
              <div data-i18n="Analytics">TYNs</div>
            </Link>
          </li>
        )}

        {(hasPermission("visitors-general-list") ||
          hasPermission("visitors-chief-guest-list") ||
          hasPermission("visitors-power-date-list") ||
          hasPermission("visitors-inductions-list")) && (
          <li
            className="menu-item dropdown_menu"
            onClick={toggleVisitorsSubMenu}
          >
            <div className="dropdown_title">
              <div className="dropdown_it">
                <SidebarAchieverIcon src={visitorsIcon} alt="Visitors" />
                <h2>Visitors</h2>
              </div>
              <i
                className={
                  showVisitorsSubMenu ? "bx bx-chevron-up" : "bx bx-chevron-down"
                }
              ></i>
            </div>
            {showVisitorsSubMenu && (
              <ul className="sub-menu">
                <>
                  {hasPermission("visitors-general-list") && (
                    <li>
                      <Link
                        className={
                          visitorGeneralRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/visitors/general"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">General</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("visitors-chief-guest-list") && (
                    <li>
                      <Link
                        className={
                          visitorChiefGuestRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/visitors/chief-guest"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Chief Guest</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("visitors-inductions-list") && (
                    <li>
                      <Link
                        className={
                          visitorInductionsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/visitors/inductions"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Inductions</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("visitors-power-date-list") && (
                    <li>
                      <Link
                        className={
                          visitorPowerDateRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/visitors/power-date"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Power Date</div>
                      </Link>
                    </li>
                  )}
                </>
              </ul>
            )}
          </li>
        )}

        {hasPermission("events-list") && (
          <li className={eventRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/events" onClick={closeDrawer}>
              <SidebarAchieverIcon src={eventsIcon} alt="Events" />
              <div data-i18n="Analytics">Events</div>
            </Link>
          </li>
        )}

        {hasPermission("news-list") && (
          <li className={newsRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/news" onClick={closeDrawer}>
              <SidebarAchieverIcon src={newsIcon} alt="News Feed" />
              <div data-i18n="Analytics">News Feed</div>
            </Link>
          </li>
        )}

        {hasPermission("feed-posts-list") && (
          <li className={feedPostsRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/feed-posts" onClick={closeDrawer}>
              <SidebarAchieverIcon src={leadsIcon} alt="Leads" />
              <div data-i18n="Analytics">Leads</div>
            </Link>
          </li>
        )}

        {(hasPermission("incomes-list") ||
          hasPermission("expenses-list") ||
          hasPermission("sponsors-list")) && (
          <li
            className={
              financeRoutes()
                ? "menu-item dropdown_menu active"
                : "menu-item dropdown_menu"
            }
            onClick={toggleFinanceSubMenu}
          >
            <div className="dropdown_title">
              <div className="dropdown_it">
                <SidebarAchieverIcon src={incomesIcon} alt="Finance" />
                <h2>Finance</h2>
              </div>
              <i
                className={
                  showFinanceSubMenu ? "bx bx-chevron-up" : "bx bx-chevron-down"
                }
              ></i>
            </div>
            {showFinanceSubMenu && (
              <ul className="sub-menu">
                <>
                  {hasPermission("incomes-list") && (
                    <li>
                      <Link
                        className={
                          incomesRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/incomes"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Incomes</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("expenses-list") && (
                    <li>
                      <Link
                        className={
                          expensesRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/expenses"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Expenses</div>
                      </Link>
                    </li>
                  )}
                  {hasPermission("sponsors-list") && (
                    <li>
                      <Link
                        className={
                          sponsorsRoutes()
                            ? "submenu-link active_submenu"
                            : "submenu-link"
                        }
                        to="/sponsors"
                        onClick={closeDrawer}
                      >
                        <div data-i18n="Analytics">Sponsors</div>
                      </Link>
                    </li>
                  )}
                </>
              </ul>
            )}
          </li>
        )}

        {hasPermission("testimonials-list") && (
          <li
            className={testimonialsRoutes() ? "menu-item active" : "menu-item"}
          >
            <Link
              className="menu-link"
              to="/testimonials"
              onClick={closeDrawer}
            >
              <SidebarAchieverIcon src={testimonialsIcon} alt="Testimonials" />
              <div data-i18n="Analytics">Testimonials</div>
            </Link>
          </li>
        )}
        {(hasPermission("reports-tyns-list") ||
          hasPermission("reports-biz-given-list") ||
          hasPermission("reports-121s-list") ||
          hasPermission("reports-referrals-list") ||
          hasPermission("reports-visitors-list") ||
          hasPermission("reports-visitors-general-list") ||
          hasPermission("reports-visitors-chief-guest-list") ||
          hasPermission("reports-visitors-power-date-list") ||
          hasPermission("reports-visitors-inductions-list") ||
          hasPermission("reports-reward-points") ||
          hasPermission("reports-fees-list") ||
          hasPermission("reports-attendance-list") ||
          hasPermission("reports-overall-list") ||
          hasPermission("reports-ledger-list") ||
          hasPermission("reports-membership-expiry-renewal-list") ||
          hasPermission("reports-chapter-wise-business-list") ||
          hasPermission("reports-chapter-wise-one-to-one-list") ||
          hasPermission("reports-chapter-wise-referrals-list") ||
          hasPermission("reports-chapter-wise-visitors-list")) && (
          <li
            className="menu-item dropdown_menu"
            onClick={toggleReportsSubMenu}
          >
            <div className="dropdown_title">
              <div className="dropdown_it">
                <SidebarAchieverIcon src={reportsIcon} alt="Reports" />
                <h2>Reports</h2>
              </div>
              <i
                className={
                  showReportsSubMenu ? "bx bx-chevron-up" : "bx bx-chevron-down"
                }
              ></i>
            </div>
            {showReportsSubMenu && (
              <ul className="sub-menu">
                {hasPermission("reports-tyns-list") && (
                  <li>
                    <Link
                      className={
                        tyfcbReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/tyfcbs"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">TYNs</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-biz-given-list") && (
                  <li>
                    <Link
                      className={
                        bizgivenReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/biz-given"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">BIZ Given</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-121s-list") && (
                  <li>
                    <Link
                      className={
                        onetooneReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/one-to-one"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">R2R</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-referrals-list") && (
                  <li>
                    <Link
                      className={
                        referralReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/referrals"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">RFLs</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-visitors-list") && (
                  <li>
                    <Link
                      className={
                        visitorsReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/visitors"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Visitors</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-visitors-general-list") && (
                  <li>
                    <Link
                      className={
                        visitorsGeneralReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/visitors-general"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Visitors - General</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-visitors-chief-guest-list") && (
                  <li>
                    <Link
                      className={
                        visitorsChiefGuestReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/visitors-chief-guest"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Visitors - Chief Guest</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-visitors-inductions-list") && (
                  <li>
                    <Link
                      className={
                        visitorsInductionReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/visitors-inductions"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Visitors - Inductions</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-visitors-power-date-list") && (
                  <li>
                    <Link
                      className={
                        visitorsPowerDateReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/visitors-power-date"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Visitors - Power Date</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-reward-points") && (
                  <li>
                    <Link
                      className={
                        pointsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/points"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Reward Points</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-fees-list") && (
                  <li>
                    <Link
                      className={
                        feesReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/fees"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Fees Pending</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-attendance-list") && (
                  <li>
                    <Link
                      className={
                        attendanceReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/attendance"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Attendance Reports</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-overall-list") && (
                  <li>
                    <Link
                      className={
                        overallReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/overall"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Overall Reports</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-membership-expiry-renewal-list") && (
                  <li>
                    <Link
                      className={
                        membershipExpiryRenewalReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/membership-expiry-renewals"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">
                        Membership Expiry & Renewals
                      </div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-ledger-list") && (
                  <li>
                    <Link
                      className={
                        ledgerReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/ledger"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Incomes & Expenses Ledger</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-chapter-wise-business-list") && (
                  <li>
                    <Link
                      className={
                        chapterWiseBusinessReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/chapter-wise-business"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Chapter Wise Business</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-chapter-wise-one-to-one-list") && (
                  <li>
                    <Link
                      className={
                        chapterWiseOnetoOneReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/chapter-wise-one-to-one"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Chapter Wise R2R</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-chapter-wise-referrals-list") && (
                  <li>
                    <Link
                      className={
                        chapterWiseReferralsReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/chapter-wise-referrals"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Chapter Wise Referrals</div>
                    </Link>
                  </li>
                )}
                {hasPermission("reports-chapter-wise-visitors-list") && (
                  <li>
                    <Link
                      className={
                        chapterWiseVisitorsReportsRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/reports/chapter-wise-visitors"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Chapter Wise Visitors</div>
                    </Link>
                  </li>
                )}
              </ul>
            )}
          </li>
        )}

        {(hasPermission("countries-list") ||
          hasPermission("states-list") ||
          hasPermission("regions-list") ||
          hasPermission("chapters-list") ||
          hasPermission("country-admins-list") ||
          hasPermission("state-admins-list") ||
          hasPermission("region-admins-list") ||
          hasPermission("chapter-admins-list") ||
          hasPermission("user-roles-list") ||
          hasPermission("business-category-list") ||
          hasPermission("income-category-list") ||
          hasPermission("expense-category-list") ||
          hasPermission("posts-category-list") ||
          hasPermission("blood-groups-list") ||
          hasPermission("sponsors-category-list") ||
          hasPermission("timers-list") ||
          hasPermission("timer-access-list") ||
          hasPermission("chapter-finance-access-list")) && (
          <li
            className="menu-item dropdown_menu"
            onClick={toggleMastersSubMenu}
          >
            <div className="dropdown_title">
              <div className="dropdown_it">
                <SidebarAchieverIcon src={mastersIcon} alt="Masters" />
                <h2>Masters</h2>
              </div>
              <i
                className={
                  showMastersSubMenu ? "bx bx-chevron-up" : "bx bx-chevron-down"
                }
              ></i>
            </div>
            {showMastersSubMenu && (
              <ul className="sub-menu">
                {hasPermission("countries-list") && (
                  <li>
                    <Link
                      className={
                        countryRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/countries"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Countries</div>
                    </Link>
                  </li>
                )}
                {hasPermission("states-list") && (
                  <li>
                    <Link
                      className={
                        stateRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/states"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">States</div>
                    </Link>
                  </li>
                )}
                {hasPermission("regions-list") && (
                  <li>
                    <Link
                      className={
                        regionRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/regions"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Regions</div>
                    </Link>
                  </li>
                )}
                {hasPermission("chapters-list") && (
                  <li>
                    <Link
                      className={
                        chapterRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/chapters"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Chapters</div>
                    </Link>
                  </li>
                )}
                {hasPermission("country-admins-list") && (
                  <li>
                    <Link
                      className={
                        countryAdminRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/country-admin-users"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Country Admins</div>
                    </Link>
                  </li>
                )}
                {hasPermission("state-admins-list") && (
                  <li>
                    <Link
                      className={
                        stateAdminRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/state-admin-users"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">State Admins</div>
                    </Link>
                  </li>
                )}
                {hasPermission("region-admins-list") && (
                  <li>
                    <Link
                      className={
                        regionAdminRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/region-admin-users"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Region Admins</div>
                    </Link>
                  </li>
                )}
                {hasPermission("chapter-admins-list") && (
                  <li>
                    <Link
                      className={
                        chapterAdminRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/chapter-admin-users"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Chapter Admins</div>
                    </Link>
                  </li>
                )}
                {hasPermission("user-roles-list") && (
                  <li>
                    <Link
                      className={
                        userRoleRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/user-roles"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">User Roles</div>
                    </Link>
                  </li>
                )}
                {hasPermission("business-category-list") && (
                  <li>
                    <Link
                      className={
                        categoryRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/category"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Business Category</div>
                    </Link>
                  </li>
                )}
                {hasPermission("income-category-list") && (
                  <li>
                    <Link
                      className={
                        incomeCategoryRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/income-category"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Income Category</div>
                    </Link>
                  </li>
                )}
                {hasPermission("expense-category-list") && (
                  <li>
                    <Link
                      className={
                        expenseCategoryRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/expense-category"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Expense Category</div>
                    </Link>
                  </li>
                )}
                {hasPermission("posts-category-list") && (
                  <li>
                    <Link
                      className={
                        postsCategoryRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/posts-category"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Leads Category</div>
                    </Link>
                  </li>
                )}
                {hasPermission("sponsors-category-list") && (
                  <li>
                    <Link
                      className={
                        sponsorsCategoryRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/sponsors-category"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Sponsors Category</div>
                    </Link>
                  </li>
                )}

                {hasPermission("blood-groups-list") && (
                  <li>
                    <Link
                      className={
                        bloodgroupRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/blood-groups"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Blood Groups</div>
                    </Link>
                  </li>
                )}
                {/* {hasPermission("crowns-list") && (
                  <li>
                    <Link
                      className={
                        crownRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/crowns"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Crowns</div>
                    </Link>
                  </li>
                )} */}
                {hasPermission("timers-list") && (
                  <li>
                    <Link
                      className={
                        timerRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/timers"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Timers</div>
                    </Link>
                  </li>
                )}
                {hasPermission("timer-access-list") && (
                  <li>
                    <Link
                      className={
                        timerAccessRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/timer-access"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Timer Access</div>
                    </Link>
                  </li>
                )}
                {hasPermission("chapter-finance-access-list") && (
                  <li>
                    <Link
                      className={
                        chapterFinanceAccessRoutes()
                          ? "submenu-link active_submenu"
                          : "submenu-link"
                      }
                      to="/chapter-finance-access"
                      onClick={closeDrawer}
                    >
                      <div data-i18n="Analytics">Chapter Finance Access</div>
                    </Link>
                  </li>
                )}
              </ul>
            )}
          </li>
        )}

        {hasPermission("points-system-list") && (
          <li
            className={pointsSystemRoutes() ? "menu-item active" : "menu-item"}
          >
            <Link
              className="menu-link"
              to="/points-system"
              onClick={closeDrawer}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div data-i18n="Points System">Points System</div>
            </Link>
          </li>
        )}

        {hasPermission("roles-list") && (
          <li className={roleRoutes() ? "menu-item active" : "menu-item"}>
            <Link className="menu-link" to="/roles" onClick={closeDrawer}>
              <SidebarAchieverIcon src={rolesIcon} alt="Roles & Permissions" />
              <div data-i18n="Analytics">Roles & Permissions</div>
            </Link>
          </li>
        )}

        {/* {hasPermission("settings-list") && (
          <li className={settingsRoutes() ? "menu-item active" : "menu-item"}>
            <Link
              className="menu-link"
              to="/attendance-qr-code"
              onClick={closeDrawer}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 3H7V7H3V3ZM17 3H21V7H17V3ZM3 17H7V21H3V17ZM17 17H21V21H17V17Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
                <path
                  d="M9 9H15V15H9V9Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
              </svg>
              <div data-i18n="Analytics">Attendance QR Code</div>
            </Link>
          </li>
        )} */}

        {/* {isSuperAdmin === 1 && (
          <li
            className={
              memberMonthlyReportsRoutes() ? "menu-item active" : "menu-item"
            }
          >
            <Link
              className="menu-link"
              to="/member_monthly_reports"
              onClick={closeDrawer}
            >
              <SidebarAchieverIcon
                src={reportsIcon}
                alt="Member Monthly Reports"
              />
              <div data-i18n="Analytics">Member Monthly Reports</div>
            </Link>
          </li>
        )} */}

        {/* {hasPermission("forum-settings-list") && (
          <li
            className={forumSettingsRoutes() ? "menu-item active" : "menu-item"}
          >
            <Link
              className="menu-link"
              to="/forum-settings"
              onClick={closeDrawer}
            >
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.32"
                    d="M19.14 12.94c.04-.31.06-.63.06-.94 0-.31-.02-.63-.06-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.49.49 0 0 0-.59-.22l-2.39.96a7.03 7.03 0 0 0-1.63-.94l-.36-2.54A.48.48 0 0 0 14 2h-4a.48.48 0 0 0-.48.41l-.36 2.54c-.59.24-1.13.56-1.63.94l-2.39-.96a.49.49 0 0 0-.59.22L2.63 8.87a.49.49 0 0 0 .12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.04.7 1.63.94l.36 2.54c.05.24.24.41.48.41h4c.24 0 .44-.17.48-.41l.36-2.54c.59-.24 1.13-.56 1.63-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32a.49.49 0 0 0-.12-.61l-2.03-1.58z"
                    fill="currentColor"
                  />
                  <path
                    d="M12 15.5A3.5 3.5 0 1 0 12 8.5a3.5 3.5 0 0 0 0 7z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div data-i18n="Analytics">Forum Settings</div>
            </Link>
          </li>
        )} */}
      </ul>
    </aside>
  );
};

export default Sidebar;
